import React, { Component } from "react";
import { Grid, List, ListItem, ListItemIcon, ListItemText, Icon, Divider, Button } from "@mui/material";
import AnchorLink from "react-anchor-link-smooth-scroll";

import env from "../../../env";

import Animate from "../../components/Animations";
import Presentation from "../../components/Presentation";
import Reactor from "../../components/Reactor";
import Screen from "../../components/Screen";
import Text from "../../components/Text";

import "./CityHall.styl";

class CityHall extends Component {
    render() {
        return (
            <div tabIndex={0} aria-label="Conteúdo da Página Prefeituras" className="CityHall">
                <section id="presentation" className="frame padded flex ai-c" aria-label="Apresentação do produto para prefeituras" style={{ backgroundImage: `url(${env.images.city})`}}>
                    <div className="darken">
                        <Text className="header align-center flex ai-c jc-c" as="h1"><Icon className="icon">location_city</Icon>Prefeituras</Text>
                        <Text className="align-center">Conheça as vantagens de utilizar o Geolux como sua ferramenta de gestão de iluminação pública.</Text>
                    </div>
                </section>
                <section id="banner" className="frame padded app background white">
                    <div className="container">
                        <Reactor>
                        {
                            ({ visible }) => (
                                <Presentation paused={!visible} forwardOnly>
                                    <Presentation.Slide duration={7000}>
                                    {
                                        ({ active }) => (
                                            <Grid container>
                                                <Grid item xs={12} md={6} className="text-column flex ai-c jc-c">
                                                    <Animate in={active} fadeInRight>
                                                        <div className="align-center"><Icon className="icon">location_city</Icon></div>
                                                        <Text className="text align-center">Como é a gestão da iluminação pública em sua cidade?</Text>
                                                    </Animate>
                                                </Grid>
                                                <Grid item xs={12} md={6} className="image-column flex jc-c">
                                                    <Animate in={active} fadeInLeft>
                                                        <img className="image" src={env.images.lightBulbInChalkboard} alt="Lâmpada em cima de um quadro negro, representando ideias relacionadas" />
                                                    </Animate>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Grid container>
                                                <Grid item xs={12} md={6} className="text-column flex ai-c jc-c">
                                                    <Animate in={active} fadeInRight>
                                                        <div className="align-center"><Icon className="icon">wb_incandescent</Icon></div>
                                                        <Text className="text align-center">Como se compõe seu parque de iluminação hoje?</Text>
                                                    </Animate>
                                                </Grid>
                                                <Grid item xs={12} md={6} className="image-column flex jc-c">
                                                    <Animate in={active} fadeInLeft>
                                                        <img className="image" src={env.images.cityHall.carousel.map} alt="Exemplo do mapa de pontos luminosos do Geolux" />
                                                    </Animate>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Grid container>
                                                <Grid item xs={12} md={4} className="text-column flex ai-c jc-c">
                                                    <Animate in={active} fadeInRight>
                                                        <div className="align-center">
                                                            <Icon className="icon">pie_chart</Icon>
                                                            <Icon className="icon">insert_chart_outlined</Icon>
                                                            <Icon className="icon">show_chart</Icon>
                                                        </div>
                                                        <Text className="text align-center">Qual foi o gasto com materiais e serviços nos últimos meses?</Text>
                                                    </Animate>
                                                </Grid>
                                                <Grid item xs={12} md={8} className="image-column flex jc-c">
                                                    <Animate in={active} fadeInLeft>
                                                        <img className="image" src={env.images.cityHall.carousel.expenses} alt="Gráfico mostrando o gasto mensal da cidade com manutenção" />
                                                    </Animate>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Grid container>
                                                <Grid item xs={12} md={4} className="text-column flex ai-c jc-c">
                                                    <Animate in={active} fadeInRight>
                                                        <div className="align-center"><Icon className="icon">phone_in_talk</Icon></div>
                                                        <Text className="text align-center">Você sabe quanto tempo leva, em média, para uma solicitação ser atendida?</Text>
                                                    </Animate>
                                                </Grid>
                                                <Grid item xs={12} md={8} className="image-column flex jc-c">
                                                    <Animate in={active} fadeInLeft>
                                                        <img className="image" src={env.images.cityHall.carousel.averageTime} alt="Tabela mostrando tempo de execução de cada Ordem de Serviço, além do tempo médio" />
                                                    </Animate>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Grid container>
                                                <Grid item xs={12} md={7} className="text-column flex ai-c jc-c">
                                                    <Animate in={active} fadeInRight>
                                                        <div className="align-center"><Icon className="icon">show_chart</Icon></div>
                                                        <Text className="text align-center">Qual o índice de materiais que são reportados com defeito dentro da garantia?</Text>
                                                    </Animate>
                                                </Grid>
                                                <Grid item xs={12} md={5} className="image-column flex jc-c">
                                                    <Animate in={active} fadeInLeft>
                                                        <img className="image" src={env.images.cityHall.carousel.warranty} alt="Tabela com índices de materiais com defeito dentro da garantia" />
                                                    </Animate>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <Grid container>
                                                <Grid item xs={12} md={6} className="text-column flex ai-c jc-c">
                                                    <Animate in={active} fadeInRight>
                                                        <div className="align-center"><Icon className="icon">insert_chart_outlined</Icon></div>
                                                        <Text className="text align-center">Como está a produtividade das equipes de manutenção?</Text>
                                                    </Animate>
                                                </Grid>
                                                <Grid item xs={12} md={6} className="image-column flex jc-c">
                                                    <Animate in={active} fadeInLeft>
                                                        <img className="image" src={env.images.cityHall.carousel.teamProductivity} alt="Exemplo de gráficos mostrando a produtividade das equipes de manutenção" />
                                                    </Animate>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                    </Presentation.Slide>
                                    <Presentation.Slide>
                                    {
                                        ({ active }) => (
                                            <div className="logo-slide flex ai-c jc-c">
                                                <div>
                                                    <Animate in={active} fadeInDown>
                                                        <div className="flex ai-c jc-c">
                                                            <div>
                                                                <div className="flex jc-c">
                                                                    <img src={env.images.geoluxLogo} alt="Logo do Geolux" />
                                                                </div>
                                                                <Text className="text align-center">Com o Geolux você terá todas estas respostas!</Text>
                                                            </div>
                                                        </div>
                                                    </Animate>
                                                    <Animate in={active} fadeInUp inDelay={1000}>
                                                        <div className="flex jc-c">
                                                            <AnchorLink offset={80} tabIndex={-1} aria-hidden href="#communication-channels">
                                                                <Button className="button">Saiba Mais</Button>
                                                            </AnchorLink>
                                                        </div>
                                                    </Animate>
                                                </div>
                                            </div>
                                        )
                                    }
                                    </Presentation.Slide>
                                </Presentation>
                            )
                        }
                        </Reactor>
                    </div>
                </section>
                <section id="communication-channels" className="dark image frame padded equally" aria-label="Conheça nossos canais de atendimento">
                    <Text as="h1" className="flex ai-c main header"><Icon className="header-icon">thumb_up</Icon>Benefícios</Text>
                    <Divider className="section-divider" />
                    <div className="flex row reverse">
                        <Screen notebook>
                            <div className="flex ai-c jc-c flex-3">
                                <div>
                                    <div className="flex jc-c">
                                        <img tabIndex={0} className="image tall" src={env.images.selfServiceWebsite} title="Site de autoatendimento de Aracaju (simplificado)" alt="Imagem simplificada do site de autoatendimento do Geolux em Aracaju" />
                                    </div>
                                    <Text tabIndex={-1} className="image-subtitle">Site de autoatendimento de Aracaju (simplificado)</Text>
                                    <div className="flex jc-c">
                                        <img tabIndex={0} className="image" src={env.images.telegramBot.chatExample} title="Exemplo de conversa com o bot do Geolux no Telegram" alt="Exemplo de conversa com o bot do Geolux no Telegram" />
                                    </div>
                                    <Text tabIndex={-1} className="image-subtitle">Exemplo de conversa com o bot do Geolux no Telegram.</Text>
                                </div>
                            </div>
                        </Screen>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="align-left flex ai-c header" as="h2"><Icon className="header-icon">category</Icon>Canais de Comunicação</Text>
                                <List>
                                    <AnchorLink offset={80} tabIndex={-1} aria-hidden href="#self-service-website">
                                        <ListItem button aria-label="Site de Autoatendimento">
                                            <ListItemIcon><Icon className="icon">web</Icon></ListItemIcon>
                                            <ListItemText>
                                                <Text className="text" tabIndex={-1} aria-hidden>Site de Autoatendimento</Text>
                                            </ListItemText>
                                        </ListItem>
                                    </AnchorLink>
                                    <AnchorLink offset={80} tabIndex={-1} aria-hidden href="#call-center">
                                        <ListItem button aria-label="Integre o Geolux com o seu call center">
                                            <ListItemIcon><Icon className="icon">phone_in_talk</Icon></ListItemIcon>
                                            <ListItemText>
                                                <Text className="text" tabIndex={-1} aria-hidden>Integre o Geolux com o seu call center</Text>
                                            </ListItemText>
                                        </ListItem>
                                    </AnchorLink>
                                    <AnchorLink offset={80} tabIndex={-1} aria-hidden href="#virtual-attendants">
                                        <ListItem button aria-label="Atendentes virtuais (Telegram e Facebook)">
                                            <ListItemIcon><Icon className="icon">smartphone</Icon></ListItemIcon>
                                            <ListItemText>
                                                <Text className="text" tabIndex={-1} aria-hidden>Atendentes virtuais (Telegram e Facebook)</Text>
                                            </ListItemText>
                                        </ListItem>
                                    </AnchorLink>
                                </List>
                                <Divider className="section-divider" />
                                <section id="self-service-website" aria-label="Como funciona nosso site de autoatendimento automatizado">
                                    <Text className="align-left flex ai-c header" as="h2"><Icon className="header-icon">language</Icon>Autoatendimento</Text>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Site simples e objetivo para abrir reclamações</Text></ListItemText>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Integrado diretamente com o sistema Geolux</Text></ListItemText>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Equipes podem executar as ordens de serviço abertas imediatamente</Text></ListItemText>
                                        </ListItem>
                                    </List>
                                </section>
                                <Divider className="section-divider" />
                                <section id="call-center" aria-label="Como integrar o call center de sua cidade com o Geolux">
                                    <Text className="flex ai-c header" as="h2"><Icon className="header-icon">phone</Icon>Call Center</Text>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Integre o Geolux facilmente com sua central de atendimento</Text></ListItemText>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Ordens de serviço são criadas durante a conversa</Text></ListItemText>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Cidadãos que preferem ligar podem receber um atendimento mais rápido e objetivo</Text></ListItemText>
                                        </ListItem>
                                    </List>
                                </section>
                                <Divider className="section-divider" />
                                <section id="virtual-attendants" aria-label="Utilize nossos atendentes virtuais para abrir Ordens de Serviço em sua cidade">
                                    <Text className="align-left flex ai-c header" as="h2"><Icon className="header-icon">headset_mic</Icon>Atendentes Virtuais</Text>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Disponíveis no Telegram e Facebook Messenger</Text></ListItemText>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Conversas intuitivas, rápidas e objetivas</Text></ListItemText>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon><Icon className="icon">done_outline</Icon></ListItemIcon>
                                            <ListItemText><Text className="text">Funcionamento 24 horas, totalmente automático</Text></ListItemText>
                                        </ListItem>
                                    </List>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="energy-consumption" className="dark image frame padded equally">
                    <div className="flex row">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="align-left flex ai-c header mobile" as="h2"><Icon className="header-icon">score</Icon>Consumo de Energia</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.energyConsumption} title="Você sabe explicar os gastos de energia da cidade?" alt="Cofrinho com várias moedas em volta" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Você sabe explicar os gastos de energia da cidade?</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="align-left flex ai-c header desktop" as="h2"><Icon className="header-icon">score</Icon>Consumo de Energia</Text>
                                <Text className="text">Existem vários relatórios relacionados ao consumo de energia. Você pode visualizar o consumo total, consumo de cada região, consumo de cada bairro, entre outros.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="in-field-operations" className="dark image frame padded equally">
                    <div className="flex row reverse">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">location_on</Icon>Operações em Campo</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.inFieldOperations} title="Atualize e acompanhe as execuções de OSs em tempo real" alt="Três celulares mostrando diferentes páginas do aplicativo do Geolux para equipes de suporte." />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Atualize e acompanhe as execuções de OSs em tempo real.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">location_on</Icon>Operações em Campo</Text>
                                <Text className="text">O Geolux conta com um aplicativo que permite suas equipes de manutenção atualizar e abrir novas ordens de serviço em tempo real.</Text>
                                <Text className="text">Se o local não possuir conexão, não tem problema! O sistema irá sincronizar os dados assim que a equipe conseguir se conectar.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="ilumination-park" className="dark image frame padded equally">
                    <div className="flex row">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">lightbulb_outline</Icon>Parque de Iluminação</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.iluminationPark} title="Visualize seu parque de iluminação com o mapa de pontos luminosos" alt="Exemplo do mapa de pontos luminosos do Geolux" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Visualize seu parque de iluminação com o mapa de pontos luminosos.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">lightbulb_outline</Icon>Parque de Iluminação</Text>
                                <Text className="text">Visualize como o parque de iluminação da cidade é composto com o uso de diversos tipos de mapas.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="team-management" className="dark image frame padded equally">
                    <div className="flex row reverse">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">people</Icon>Gestão de Equipes</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.teamManagement} title="Acompanhe a produtividade das suas equipes" alt="Imagem ilustrativa de uma equipe em uma reunião" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Acompanhe a produtividade das suas equipes.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">people</Icon>Gestão de Equipes</Text>
                                <Text className="text">O sistema permite que equipes e gerência visualizem todos os dados das equipes, desde rondas executadas até detalhes de cada OS.</Text>
                                <Text className="text">Com esses dados você pode identificar problemas que estão impactando na eficiência dos serviços de manutenção.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="material-management" className="dark image frame padded equally">
                    <div className="flex row">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                            <Text className="header mobile" as="h2"><Icon className="header-icon">business</Icon>Gestão de Materiais</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.stockManagement} title="Entrada e saída automatizada" alt="Várias e várias lâmpadas, umas em cima das outras" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Entrada e saída automatizada.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="flex ai-c header desktop" as="h2"><Icon className="header-icon">business</Icon>Gestão de Materiais</Text>
                                <Text className="text">Quando um serviço é executado, o sistema dá baixa em todos os materiais utilizados.</Text>
                                <Text className="text">Materiais com defeito dentro da garantia são automaticamente marcados para você poder visualizar os dados depois.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="demand-management" className="dark image frame padded equally">
                    <div className="flex row reverse">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">sentiment_very_satisfied</Icon>Gestão de Demandas</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.demandManagement} title="Encontre gargalos e melhore a eficiência de atendimento" alt="Imagem ilustrativa de pessoas analisando dados e planejando alguma coisa" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Encontre gargalos e melhore a eficiência de atendimento.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">sentiment_very_satisfied</Icon>Gestão de Demandas</Text>
                                <Text className="text">Saiba quais são os locais onde mais ordens de serviço são abertas e acompanhe o andamento das execuções.</Text>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default CityHall;
